import * as types from './constants';

const initialState = {
  list: [],
  loading: false,
  message: null,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false
};

const actions = {
  // Get Shopify Product Types
  [types.GET_SHOPIFY_PRODUCT_TYPES_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_TYPES_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_TYPES_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_TYPES_RESET]: () => {
    return { ...initialState };
  },

  // Operations
  [types.SHOPIFY_PRODUCT_TYPES_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
